// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_coursesPageContainer__dCx7I {
  width: 100%;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
}

.styles_container__wCi3R {
  width: 100%;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  border-radius: 40px;
  background: var(--color-white);
  box-sizing: border-box;
}
@media (min-width: 768px) {
  .styles_container__wCi3R {
    max-width: 1200px;
    padding: 40px;
    border: none;
  }
}

@media (max-width: 768px) {
  .styles_coursesPageContainer__dCx7I {
    padding: 16px 0px;
    justify-content: flex-start;
  }
  .styles_container__wCi3R {
    padding: 16px 8px;
    border-radius: 24px;
  }
}
.styles_headerRow__sv2\\+u {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
}

.styles_addCoursesButton__jQEIh {
  position: absolute;
  right: 0;
  top: 10%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  font-weight: 450;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.styles_addCoursesButton__jQEIh:hover {
  color: var(--color-primary);
  background: var(--color-blue-light);
}
.styles_addCoursesButton__jQEIh .styles_buttonText__uQolA {
  display: inline;
}
.styles_addCoursesButton__jQEIh .styles_buttonIcon__mr2w7 {
  display: inline;
}
@media (max-width: 768px) {
  .styles_addCoursesButton__jQEIh .styles_buttonText__uQolA {
    display: none;
  }
  .styles_addCoursesButton__jQEIh .styles_buttonIcon__mr2w7 {
    display: inline;
    font-size: 30px;
  }
}

.styles_pageHeader__epwZC {
  text-align: center;
  margin-bottom: 24px;
  width: 100%;
}

.styles_pageIcon__U5cGP {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 28px;
}

.styles_pageTitle__XqYxD {
  font: var(--typography-heading-l);
  color: var(--color-text-primary);
  margin-bottom: 8px;
}

.styles_pageSubtitle__DkQOL {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
}

.styles_coursesGrid__mf2ZG {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .styles_coursesGrid__mf2ZG {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .styles_coursesGrid__mf2ZG {
    grid-template-columns: repeat(2, 1fr);
  }
}

.styles_courseCard__KwWaj {
  background: var(--color-white);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.styles_courseCard__KwWaj:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.styles_courseCard__KwWaj.styles_expanded__hZa6B {
  grid-column: 1/-1;
  cursor: default;
}
.styles_courseCard__KwWaj.styles_expanded__hZa6B:hover {
  transform: none;
}
.styles_courseCard__KwWaj.styles_deleted__lEDJF {
  opacity: 0.5;
}

.styles_expandedContent__JFeMS {
  padding: 20px;
  border-top: 1px solid var(--color-border-light, rgba(0, 0, 0, 0.1));
  animation: styles_slideDown__LOywT 0.3s ease;
}

@keyframes styles_slideDown__LOywT {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 500px;
  }
}
.styles_courseDetails__O0PC6 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}
@media (min-width: 640px) {
  .styles_courseDetails__O0PC6 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
  }
}

.styles_detailItem__fuCNU {
  display: flex;
  align-items: center;
  gap: 8px;
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
}
.styles_detailItem__fuCNU .styles_detailIcon__7pc9h {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background-secondary, rgba(0, 0, 0, 0.05));
  border-radius: 4px;
  font-size: 14px;
}

.styles_actionButtons__5-TW3 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (min-width: 640px) {
  .styles_actionButtons__5-TW3 {
    flex-direction: row;
  }
  .styles_actionButtons__5-TW3 button {
    flex: 1 1;
  }
  .styles_actionButtons__5-TW3 button:last-child {
    flex: 0 0 auto;
  }
}

.styles_noCoursesContainer__I7h4x {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
}

.styles_noCoursesMessage__BS\\+\\+k {
  color: var(--color-text-secondary);
  font: var(--typography-body-l-regular);
  font-style: italic;
  text-align: center;
  margin: 0;
}

.styles_coursesTableMobile__4b\\+7V,
.styles_coursesTableDesktop__XocPe {
  display: none;
}

.styles_coursesBottomActions__bX5Jk {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}
@media (min-width: 768px) {
  .styles_coursesBottomActions__bX5Jk {
    flex-direction: row;
    justify-content: center;
    gap: 16px;
  }
  .styles_coursesBottomActions__bX5Jk button {
    min-width: 180px;
  }
}

.styles_tasksWidget__ar6Nz {
  width: 100%;
  background: var(--color-white);
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.styles_tasksHeader__HqnWM {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 16px 0;
  padding: 6px 20px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  background: var(--color-white);
  width: fit-content;
}
.styles_tasksHeader__HqnWM h2 {
  font: var(--typography-heading-m);
  color: var(--color-text-primary);
  margin: 0;
  text-align: center;
  font-size: 18px;
}

.styles_tasksContent__s844- {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;
}
@media (min-width: 768px) {
  .styles_tasksContent__s844- {
    grid-template-columns: repeat(2, 1fr);
  }
}

.styles_tasksSection__2v9Q8 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: var(--color-white);
  overflow: visible;
  min-height: 150px;
}

.styles_sectionTitle__F-Fd- {
  font: var(--typography-heading-xs);
  color: var(--color-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  flex-shrink: 0;
  text-align: center;
}

.styles_tasksList__Y\\+nI3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 8px 4px 2px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 200px;
}
.styles_tasksList__Y\\+nI3::-webkit-scrollbar {
  width: 8px;
}
.styles_tasksList__Y\\+nI3::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin: 4px 0;
}
.styles_tasksList__Y\\+nI3::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.styles_tasksList__Y\\+nI3::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.45);
}
.styles_tasksList__Y\\+nI3::-webkit-scrollbar-thumb:active {
  background: rgba(0, 0, 0, 0.6);
}
.styles_tasksList__Y\\+nI3 {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.08);
}

.styles_emptyState__YmL7I {
  padding: 24px;
  text-align: center;
  background: var(--color-background-secondary, rgba(0, 0, 0, 0.02));
  border-radius: 8px;
}

.styles_emptyText__ki77k {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
  font-style: italic;
  margin: 0;
}

.styles_tasksLoading__vknrb {
  padding: 24px;
  text-align: center;
  color: var(--color-text-secondary);
}

.styles_tasksError__i5SP- {
  padding: 16px;
  background: var(--color-danger-light, rgba(220, 38, 38, 0.1));
  border: 1px solid var(--color-danger, #dc2626);
  border-radius: 8px;
  color: var(--color-danger, #dc2626);
  font: var(--typography-body-s-regular);
}`, "",{"version":3,"sources":["webpack://./src/screens/courses/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAAF;ACdE;EDKF;IAYI,iBAAA;IACA,aAAA;IACA,YAAA;EACF;AACF;;AAGA;EACE;IACE,iBAAA;IACA,2BAAA;EAAF;EAGA;IACE,iBAAA;IACA,mBAAA;EADF;AACF;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAHF;AAKE;EACE,2BAAA;EACA,mCAAA;AAHJ;AAME;EACE,eAAA;AAJJ;AAOE;EACE,eAAA;AALJ;AASE;EACE;IACE,aAAA;EAPJ;EASE;IACE,eAAA;IACA,eAAA;EAPJ;AACF;;AAYA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AATF;;AAYA;EACE,iCAAA;EACA,gCAAA;EACA,kBAAA;AATF;;AAYA;EACE,sCAAA;EACA,kCAAA;AATF;;AAaA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAVF;ACtHE;ED2HF;IAQI,qCAAA;EATF;AACF;AC/GE;ED+GF;IAYI,qCAAA;EARF;AACF;;AAWA;EACE,8BAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AARF;AAUE;EACE,2BAAA;EACA,0CAAA;AARJ;AAWE;EACE,iBAAA;EACA,eAAA;AATJ;AAWI;EACE,eAAA;AATN;AAaE;EACE,YAAA;AAXJ;;AA2BA;EACE,aAAA;EACA,mEAAA;EACA,4CAAA;AAxBF;;AA2BA;EACE;IACE,UAAA;IACA,aAAA;EAxBF;EA0BA;IACE,UAAA;IACA,iBAAA;EAxBF;AACF;AA2BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAzBF;AC/KE;EDoMF;IAOI,aAAA;IACA,2DAAA;IACA,SAAA;EAxBF;AACF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sCAAA;EACA,kCAAA;AAxBF;AA0BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kEAAA;EACA,kBAAA;EACA,eAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzBF;AC9ME;EDoOF;IAMI,mBAAA;EAxBF;EA0BE;IACE,SAAA;EAxBJ;EA0BI;IACE,cAAA;EAxBN;AACF;;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,kCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AA3BF;;AA+BA;;EAEE,aAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AA5BF;AChPE;EDuQF;IAQI,mBAAA;IACA,uBAAA;IACA,SAAA;EA3BF;EA6BE;IACE,gBAAA;EA3BJ;AACF;;AAgCA;EACE,WAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;AA7BF;AA+BE;EACE,iCAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;AA9BF;ACjSE;ED2TF;IAOI,qCAAA;EA7BF;AACF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,kCAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AA7BF;AAgCE;EACE,UAAA;AA9BJ;AAiCE;EACE,+BAAA;EACA,kBAAA;EACA,aAAA;AA/BJ;AAkCE;EACE,8BAAA;EACA,kBAAA;EACA,0CAAA;AAhCJ;AAkCI;EACE,+BAAA;AAhCN;AAmCI;EACE,8BAAA;AAjCN;AAGA;EAmCE,qBAAA;EACA,uDAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,kBAAA;EACA,kEAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE,sCAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,6DAAA;EACA,8CAAA;EACA,kBAAA;EACA,mCAAA;EACA,sCAAA;AAnCF","sourcesContent":["@import \"mixins\";\n.coursesPageContainer {\n  width: 100%;\n  min-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  box-sizing: border-box; \n}\n\n.container {\n  width: 100%;\n  padding: 32px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  border-radius: 40px;\n  background: var(--color-white);\n  box-sizing: border-box; \n\n  @include md {\n    max-width: 1200px; // Increased for card grid\n    padding: 40px;\n    border: none;\n  }\n}\n\n// Mobile responsive adjustments\n@media (max-width: 768px) {\n  .coursesPageContainer {\n    padding: 16px 0px;\n    justify-content: flex-start;\n  }\n\n  .container {\n    padding: 16px 8px;   \n    border-radius: 24px;\n  }\n}\n\n// Header Row - Contains page header and add button\n.headerRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  position: relative;\n}\n\n.addCoursesButton {\n  position: absolute;\n  right: 0;\n  top: 10%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 20px;\n  font-weight: 450;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n\n  &:hover {\n    color: var(--color-primary);\n    background: var(--color-blue-light);\n  }\n\n  .buttonText {\n    display: inline;\n  }\n\n  .buttonIcon {\n    display: inline;\n  }\n\n  // Just show + icon on mobile\n  @media (max-width: 768px) {\n    .buttonText {\n      display: none;\n    }\n    .buttonIcon {\n      display: inline;\n      font-size: 30px;\n    }\n  }\n}\n\n// Page Header - New addition\n.pageHeader {\n  text-align: center;\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.pageIcon {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  font-size: 28px;\n}\n\n.pageTitle {\n  font: var(--typography-heading-l);\n  color: var(--color-text-primary);\n  margin-bottom: 8px;\n}\n\n.pageSubtitle {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n}\n\n// Courses Grid - Replaces table views\n.coursesGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  width: 100%;\n  margin-bottom: 24px;\n  \n  @include sm {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  @include lg {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.courseCard {\n  background: var(--color-white);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  \n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  }\n  \n  &.expanded {\n    grid-column: 1 / -1;\n    cursor: default;\n    \n    &:hover {\n      transform: none;\n    }\n  }\n  \n  &.deleted {\n    opacity: 0.5;\n    \n    // &::after {\n    //   content: '';\n    //   position: absolute;\n    //   top: 50%;\n    //   left: 10px;\n    //   right: 10px;\n    //   height: 2px;\n    //   background: var(--color-danger, #dc2626);\n    //   transform: rotate(-2deg);\n    // }\n  }\n}\n\n// Expanded Content\n.expandedContent {\n  padding: 20px;\n  border-top: 1px solid var(--color-border-light, rgba(0, 0, 0, 0.1));\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 500px;\n  }\n}\n\n.courseDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n  \n  @include sm {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n  }\n}\n\n.detailItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n  \n  .detailIcon {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--color-background-secondary, rgba(0, 0, 0, 0.05));\n    border-radius: 4px;\n    font-size: 14px;\n  }\n}\n\n.actionButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  \n  @include sm {\n    flex-direction: row;\n    \n    button {\n      flex: 1;\n      \n      &:last-child {\n        flex: 0 0 auto;\n      }\n    }\n  }\n}\n\n// Keep existing styles\n.noCoursesContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  width: 100%;\n}\n\n.noCoursesMessage {\n  color: var(--color-text-secondary);\n  font: var(--typography-body-l-regular);\n  font-style: italic;\n  text-align: center;\n  margin: 0;\n}\n\n// Remove or hide table views since we're using grid now\n.coursesTableMobile,\n.coursesTableDesktop {\n  display: none;\n}\n\n.coursesBottomActions {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  gap: 16px;\n\n  @include md {\n    flex-direction: row;\n    justify-content: center;\n    gap: 16px;\n\n    button {\n      min-width: 180px;\n    }\n  }\n}\n\n// Tasks Widget Styles\n.tasksWidget {\n  width: 100%;\n  background: var(--color-white);\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tasksHeader {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 0 16px 0;\n  padding: 6px 20px;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  background: var(--color-white);\n  width: fit-content;\n\n  h2 {\n    font: var(--typography-heading-m);\n    color: var(--color-text-primary);\n    margin: 0;\n    text-align: center;\n    font-size: 18px;\n  }\n}\n\n.tasksContent {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  width: 100%;\n\n  @include md {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.tasksSection {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  background: var(--color-white);\n  overflow: visible;\n  min-height: 150px;\n}\n\n.sectionTitle {\n  font: var(--typography-heading-xs);\n  color: var(--color-text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 800;\n  flex-shrink: 0;\n  text-align: center;\n}\n\n.tasksList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px 8px 4px 2px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 200px; // Fallback, will be overridden by JavaScript\n\n  // Webkit browsers (Chrome, Safari, Edge)\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.08);\n    border-radius: 4px;\n    margin: 4px 0;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.5);\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.45);\n    }\n\n    &:active {\n      background: rgba(0, 0, 0, 0.6);\n    }\n  }\n\n  // Firefox\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.08);\n}\n\n.emptyState {\n  padding: 24px;\n  text-align: center;\n  background: var(--color-background-secondary, rgba(0, 0, 0, 0.02));\n  border-radius: 8px;\n}\n\n.emptyText {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n  font-style: italic;\n  margin: 0;\n}\n\n.tasksLoading {\n  padding: 24px;\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.tasksError {\n  padding: 16px;\n  background: var(--color-danger-light, rgba(220, 38, 38, 0.1));\n  border: 1px solid var(--color-danger, #dc2626);\n  border-radius: 8px;\n  color: var(--color-danger, #dc2626);\n  font: var(--typography-body-s-regular);\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coursesPageContainer": `styles_coursesPageContainer__dCx7I`,
	"container": `styles_container__wCi3R`,
	"headerRow": `styles_headerRow__sv2+u`,
	"addCoursesButton": `styles_addCoursesButton__jQEIh`,
	"buttonText": `styles_buttonText__uQolA`,
	"buttonIcon": `styles_buttonIcon__mr2w7`,
	"pageHeader": `styles_pageHeader__epwZC`,
	"pageIcon": `styles_pageIcon__U5cGP`,
	"pageTitle": `styles_pageTitle__XqYxD`,
	"pageSubtitle": `styles_pageSubtitle__DkQOL`,
	"coursesGrid": `styles_coursesGrid__mf2ZG`,
	"courseCard": `styles_courseCard__KwWaj`,
	"expanded": `styles_expanded__hZa6B`,
	"deleted": `styles_deleted__lEDJF`,
	"expandedContent": `styles_expandedContent__JFeMS`,
	"slideDown": `styles_slideDown__LOywT`,
	"courseDetails": `styles_courseDetails__O0PC6`,
	"detailItem": `styles_detailItem__fuCNU`,
	"detailIcon": `styles_detailIcon__7pc9h`,
	"actionButtons": `styles_actionButtons__5-TW3`,
	"noCoursesContainer": `styles_noCoursesContainer__I7h4x`,
	"noCoursesMessage": `styles_noCoursesMessage__BS++k`,
	"coursesTableMobile": `styles_coursesTableMobile__4b+7V`,
	"coursesTableDesktop": `styles_coursesTableDesktop__XocPe`,
	"coursesBottomActions": `styles_coursesBottomActions__bX5Jk`,
	"tasksWidget": `styles_tasksWidget__ar6Nz`,
	"tasksHeader": `styles_tasksHeader__HqnWM`,
	"tasksContent": `styles_tasksContent__s844-`,
	"tasksSection": `styles_tasksSection__2v9Q8`,
	"sectionTitle": `styles_sectionTitle__F-Fd-`,
	"tasksList": `styles_tasksList__Y+nI3`,
	"emptyState": `styles_emptyState__YmL7I`,
	"emptyText": `styles_emptyText__ki77k`,
	"tasksLoading": `styles_tasksLoading__vknrb`,
	"tasksError": `styles_tasksError__i5SP-`
};
export default ___CSS_LOADER_EXPORT___;
